export function getItem(name: string): any {
  const storage = `${window.localStorage.getItem(name)}`;
  return JSON.parse(storage);
}

export function setItem(name: string, data: any): void {
  window.localStorage.setItem(name, JSON.stringify(data));
}

export function deleteItem(name: string): void {
  window.localStorage.removeItem(name);
}

export function deleteAllStorage(): void {
  window.localStorage.clear();
}
